<template>
  <div class="fc-ex">
    <div class="fc-ex-title">
      导览
    </div>
    <!-- <div class="fc-ex-type">
      <p>请选择展会</p>
      <Checkbox v-model="exType" class="checkBox">CMEF 2020</Checkbox>
    </div> -->
    <div class="fc-ex-list" v-if="exType">
      <p>请选择类别</p>
      <div v-if="filterCommonLoading" style="text-align:center;line-height:100px;">加载中...</div>
      <span class="return" v-if="categoryFlag && !categoryFlag2" @click="returnFirst()"><i class="icon iconfont icon-xiala"></i>返回</span>
      <span class="return" v-if="categoryFlag2" @click="returnFirst2()"><i class="icon iconfont icon-xiala"></i>返回</span>
      <div v-if="!categoryFlag && categoryList && categoryList.length > 0">
        <span
          v-for="(item,index) in categoryList"
          :key="'categoryList-' + index"
          :title="item.name"
          :class="activeIndex0 === index?'active':''"
          @click="select(item,index)"
        >
          {{item.name}}
        </span>
      </div>
      <div v-if="categoryFlag && !categoryFlag2 && categoryList2 && categoryList2.length > 0">
        <span
          v-for="(item,index) in categoryList2"
          :key="'categoryList2-' + index"
          :title="item.name"
          :class="activeIndex === index?'active':''"
          @click="selectCategory(item,index)"
        >
          {{item.name}}
        </span>
      </div>
      <div v-if="categoryFlag2 && categoryList3 && categoryList3.length > 0">
        <span
          v-for="(item,index) in categoryList3"
          :key="'categoryList3-' + index"
          :title="item.name"
          :class="activeIndex2 === index?'active':''"
          @click="selectCategory2(item,index)"
        >
          {{item.name}}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  // 类别筛选
  name: "filter-common",
  props: {
    categoryList: {
      type: Array,
      default: []
    },
    filterCommonLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
      show2: false,
      exType: true,
      categoryFlag: false,
      categoryFlag2: false,
      categoryList2: [],
      categoryList3: [],
      activeIndex0:-1,
      activeIndex: -1, // 二级分类对应active
      activeIndex2: -1, // 三级分类对应active
    };
  },
  components: {},
  computed: {
    ...mapGetters({
    }),
  },
  methods: {
    select(e,index) {
     
      this.categoryFlag = true;
      this.categoryList2 = e.list;
      this.activeIndex0=index
      this.$emit("changeCategory",e.id);
    },
    selectCategory(e,index) {
      if (e.list && e.list.length > 0) {
        this.categoryFlag2 = true;
        this.categoryList3 = e.list;
        this.$emit("changeCategory",e.id);
      } else {
        this.activeIndex = index;
        this.$emit("changeCategory",e.id);
      }
    },
    selectCategory2(e,index) {
      this.activeIndex2 = index;
       console.log(index,'eeeeeee')
      this.$emit("changeCategory",e.id);
    },
    returnFirst() {
      this.categoryFlag = false;
      this.activeIndex = -1;
      this.$emit("changeCategory","");
    },
    returnFirst2() {
      this.categoryFlag2 = false;
      this.activeIndex2 = -1;
      this.$emit("changeCategory","");
    }
  }
};
</script>

<style scoped lang="scss">
.fc-ex {
  background-color: #fff;
  padding-bottom: 20px;
  margin-bottom: 20px;
  &-title {
    width: 100%;
    height: 48px;
    background-color: #024c8b;
    color: #fff;
    text-align: center;
    font-size: 20px;
    line-height: 48px;
  }
  &-type {
    p {
      font-size: 16px;
      color: #024c8b;
      padding: 20px 0 10px 20px;
    }
    .checkBox {
      width: 100%;
      margin: 0 0 10px 30px;
    }
  }
  &-list {
    p {
      font-size: 16px;
      color: #024c8b;
      padding: 20px 0 0 20px;
    }
    div {
      padding: 0 6px;
      span {
        display: block;
        width: 100%;
        // height: 30px;
        font-size: 14px;
        color: #333;
        padding-left: 24px;
        padding-right: 10px;
        cursor: pointer;
        line-height: 24px;
        // overflow: hidden;
        // text-overflow:ellipsis;
        // white-space: nowrap;
        margin: 6px 0;
        word-wrap: break-word;
        &:hover {
          background-color: #edf2f7;
          color: #024c8b;
        }
      }
    }
    .return {
      color: #333;
      margin-left: 24px;
      line-height: 30px;
      cursor: pointer;
      i {
        display: inline-block;
        transform:rotate(90deg);
        -ms-transform:rotate(90deg); 	/* IE 9 */
        -moz-transform:rotate(90deg); 	/* Firefox */
        -webkit-transform:rotate(90deg); /* Safari 和 Chrome */
        -o-transform:rotate(90deg); 	/* Opera */
      }
    }
    .active {
      background-color: #edf2f7;
      color: #024c8b;
    }
  }
}
</style>
